<template>
  <v-container id="dashboard_root" fluid>
    <business-account-banner v-if="!isAdmin"></business-account-banner>
    <business-account-invitation-banner></business-account-invitation-banner>
    <tutorial-banner v-if="!isAdmin"></tutorial-banner>

    <!-- CONTENT -->
    <v-row align="stretch">
      <v-col align-self="center" sm="12" md="6" lg="4">
        <v-container fluid class="mb-0 px-4 px-0-sm">
          <v-row align="center" align-content="center" justify="center">
            <v-col align-self="center" cols="6">
              <v-card class="mx-auto d-flex justify-center align-center" height="20vh" width="20vh">
                <v-card-text class="text-center">
                  <div id="pendingCount" class="display-2 primary--text">
                    {{ userStats.pendingCount }}
                  </div>
                  <div class="body-2">{{ $t('signatureChains.states.pending') }}</div>
                  <v-btn id="see_pending" class="body-2" text @click="navToDocuments('PENDING')">
                    {{ $t('dashboard.see') }}
                    <v-icon small>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" align-self="center">
              <v-card class="mx-auto d-flex justify-center align-center" height="20vh" width="20vh">
                <v-card-text class="py-10 text-center">
                  <div id="todoCount" class="display-2 primary--text">
                    {{ userStats.todoCount }}
                  </div>
                  <div class="body-2">{{ $t('signatureChains.states.todo') }}</div>
                  <v-btn id="see_todo" class="body-2" text @click="navToDocuments('TODO')">
                    {{ $t('dashboard.see') }}
                    <v-icon small>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row align="stretch">
            <v-col align-self="center" cols="6">
              <v-card class="mx-auto d-flex justify-center align-center" height="20vh" width="20vh">
                <v-card-text class="py-10 text-center">
                  <div id="failedCount" class="display-2 primary--text">
                    {{ userStats.failedCount }}
                  </div>
                  <div class="body-2">{{ $t('signatureChains.states.failedTypes.failed') }}</div>
                  <v-btn id="see_failed" class="body-2" text @click="navToDocuments('FAILED')">
                    {{ $t('dashboard.see') }}
                    <v-icon small>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" align-self="center">
              <v-card class="mx-auto d-flex justify-center align-center" height="20vh" width="20vh">
                <v-card-text class="py-10 text-center">
                  <div id="signedCount" class="display-2 primary--text">{{ userStats.signedCount }}</div>
                  <div class="body-2">{{ $t('signatureChains.states.completed') }}</div>
                  <v-btn id="see_signed" class="body-2" text @click="navToDocuments('SIGNED')">
                    {{ $t('dashboard.see') }}
                    <v-icon small>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>

      <!-- BIG DRAG N DROP -->
      <v-col sm="12" md="6" lg="8">
        <!-- this v-container only needed to make its conetent aligned with a 2x2 tiles -->
        <v-container fluid class="ma-0">
          <v-card width="100%" height="43.3vh">
            <drag-drop-upload
              class="white"
              max-width="100%"
              given-height="100%"
              :description="$t('dashboard.workflow.dropzoneText')"
              :disabled="!canFileDrop"
              dashboard-mode
              @uploaded="handleDragDrop"
              @error="handleDragDropError"
            >
              <template #main-action>
                <v-menu bottom offset-y>
                  <template #activator="{ on }">
                    <div class="d-inline-block">
                      <v-btn color="primary" class="pr-3 text-btn" v-on="on">
                        <span class="mr-1">{{ $t('dashboard.workflow.btnTitle') }}</span>
                        <v-spacer></v-spacer>
                      </v-btn>
                      <v-btn class="arrow-btn" color="primary" v-on="on">
                        <v-icon small>
                          mdi-arrow-down
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="flow in workflows"
                      :key="flow.icon" link
                      :disabled="isRoleDisabledForFlow(flow)"
                      @click="startWorkflow(flow.link)"
                    >
                      <v-list-item-icon class="mr-1 ml-0">
                        <v-icon :color="isRoleDisabledForFlow(flow) ? 'grey' : 'primary'">{{ flow.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="menu-link">{{ flow.text }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </drag-drop-upload>
          </v-card>
        </v-container>
      </v-col>
    </v-row>

    <!-- DOCU ROWS, keys must be valid filter values -->
    <document-row
      id="dashboard_todo"
      key="TODO"
      :no-documents="$t('dashboard.documentRows.todo.noDoc')"
      :items="todoSignatureChains"
      status="TODO"
      @changed="refreshTodoChains"
      @options-click="handleDocSelected('TODO',$event)"
    >
      <template #header>
        <v-row class="mb-2" align="baseline">
          <span class="text-h6">{{ $t('dashboard.documentRows.todo.label' ) }}</span>
          <span class="ml-4 caption grey--text">{{ '•   '+ $t('dashboard.documentRows.todo.description') }}</span>
          <v-spacer></v-spacer>
          <v-btn id="seeall_todo" text :to="{name:'SignatureChains', params: {filter:'TODO'}}">
            {{ $t('dashboard.seeAll') }}
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </document-row>

    <document-row
      id="dashboard_pending"
      key="PENDING"
      :no-documents="$t('dashboard.documentRows.pending.noDoc')"
      :items="pendingSignatureChains"
      @changed="refreshPendingChains"
      @options-click="handleDocSelected('PENDING',$event)"
    >
      <template #header>
        <v-row class="mb-2" align="baseline">
          <span class="text-h6">{{ $t('dashboard.documentRows.pending.label' ) }}</span>
          <span class="ml-4 caption grey--text">{{ '•   '+ $t('dashboard.documentRows.pending.description') }}</span>
          <v-spacer></v-spacer>
          <v-btn id="seeall_pending" text :to="{name:'SignatureChains', params: {filter:'PENDING'}}">
            {{ $t('dashboard.seeAll') }}
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </document-row>

    <document-row
      id="dashboard_signed"
      key="SIGNED"
      :no-documents="$t('dashboard.documentRows.completed.noDoc')"
      :items="signedSignatureChains"
      @changed="refreshSignedChains"
      @options-click="handleDocSelected('SIGNED',$event)"
    >
      <template #header>
        <v-row class="mb-2" align="baseline">
          <span class="text-h6">{{ $t('dashboard.documentRows.completed.label' ) }}</span>
          <span class="ml-4 caption grey--text">{{ '•   '+ $t('dashboard.documentRows.completed.description') }}</span>
          <v-spacer></v-spacer>
          <v-btn id="seeall_signed" text :to="{name:'SignatureChains', params: {filter: 'SIGNED'}}">
            {{ $t('dashboard.seeAll') }}
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </document-row>

    <v-row justify="center">
      <v-dialog v-model="centralKeyNotActiveFileDropWarning" persistent width="auto" max-width="700">
        <v-card id="no_credential_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.centralKeyNotEnabled.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.centralKeyNotEnabled.description') }}
            </div>
            <v-btn
              id="no_credential_warning_ok"
              style="text-align: center;"
              color="primary"
              class="mt-10 mb-0"
              @click="centralKeyNotActiveFileDropWarning = false"
            >
              {{ $t('signatureProfiles.error.centralKeyNotEnabled.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import seal from '@/services/api/seal.js'
import { mapGetters } from 'vuex'
import Roles from '../../Role.js'
import DocumentRow from '@/components/DocumentRow.vue'
import DragDropUpload from '@/components/DragDropUpload.vue'
import eventBus from '@/event-bus.js'
import eventTypes from '../../eventTypes'
import rssp from '@/services/api/rsspUtil.js'
import signatureChains from '@/services/api/signatureChains'
import signatureProfiles from '@/services/api/signatureProfiles.js'
import users from '@/services/api/users'
import SignatureChainListStatus from '@/views/signature/chains/SignatureChainListStatus'
import SignatureChainStatus from '../signature/chains/SignatureChainStatus'
import signatureChainType from '../signature/chains/SignatureChainType'
import TutorialBanner from './TutorialBanner.vue'
import BusinessAccountBanner from './businessAccountBanner.vue'
import BusinessAccountInvitationBanner from './businessAccountInvitationBanner.vue'

export default {
  name: 'Dashboard',

  components: {
    DragDropUpload,
    DocumentRow,
    TutorialBanner,
    BusinessAccountBanner,
    BusinessAccountInvitationBanner
  },

  beforeRouteLeave(to, from, next) {
    // ...
    eventBus.$off(eventTypes.SIGNATURE_CHAIN_CREATED, this.onChainCreated)
    eventBus.$off(eventTypes.SIGNATURE_CHAIN_UPDATED, this.onChainUpdated)
    eventBus.$off(eventTypes.SIGNATURE_CHAIN_DELETED, this.onChainDeleted)
    eventBus.$off(eventTypes.SIGNATURE_CHAIN_WITHDRAWN, this.onChainDeleted)

    next()
  },

  data() {
    return {
      // user stats
      userStats: {
        todoCount: 0,
        pendingCount: 0,
        signedCount: 0,
        failedCount: 0
      },
      // workflows
      uploadedFiles: [],
      workflows: [
        {
          text: this.$t('dashboard.workflow.signDocu'),
          icon: 'mdi-draw-pen',
          link: '/signatureChains/list'

        },
        {
          text: this.$t('dashboard.workflow.uploadDoc'),
          icon: 'mdi-cloud-upload-outline',
          link: '/signatureChains/upload',
          roles: ['creator']
        },
        {
          text: this.$t('dashboard.workflow.newSignProfile'),
          icon: 'mdi-plus-circle-outline',
          link: '/signatureProfiles/add'
        },
        {
          text: this.$t('dashboard.workflow.addDevice'),
          icon: 'mdi-cellphone-lock',
          link: '/user/profile'
        }
      ],
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      signedSignatureChains: [],
      todoSignatureChains: [],
      pendingSignatureChains: [],
      activatedCredentials: [],
      centralKeyNotActiveFileDropWarning: false
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Roles.ADMIN)
    },

    currentUser() {
      return this.$store.state.currentUser
    },
    canFileDrop() {
      return !this.sealStatus.enabled || this.sealStatus.activated || (this.activatedCredentials.length > 0)
    }
  },

  async beforeMount() {
    await this.loadUserStats()
    await this.loadAllSignatureChains()
    this.sealStatus = await seal.getSealStatus()
    await this.listMyActivatedCredentials()

    eventBus.$on(eventTypes.SIGNATURE_CHAIN_CREATED, this.onChainCreated)
    eventBus.$on(eventTypes.SIGNATURE_CHAIN_UPDATED, this.onChainUpdated)
    eventBus.$on(eventTypes.SIGNATURE_CHAIN_DELETED, this.onChainDeleted)
    eventBus.$on(eventTypes.SIGNATURE_CHAIN_WITHDRAWN, this.onChainDeleted)
  },

  methods: {

    startWorkflow(flow) {
      this.$router.push(flow)
    },

    isRoleDisabledForFlow(flow) {
      return flow.roles ? !flow.roles.every(r => this.currentUser.roles.includes(r)) : false
    },

    handleDragDrop(e) {
      if (!e || e.length === 0) {
        this.$store.commit('removeCurrentFiles')
        this.uploadedFiles = []
        return
      }

      this.uploadedFiles = Array.isArray(e) ? [...e] : [e]
      this.$store.commit('setCurrentFiles', this.uploadedFiles)

      const firstFile = this.uploadedFiles[0]
      const allPdfs = this.uploadedFiles.every(f => f.type === 'application/pdf')
      const allImages = this.uploadedFiles.every(f => f.type === 'image/png' || f.type === 'image/jpeg')

      if (allPdfs || firstFile.type === 'application/pdf') {
        this.$router.push({ name: 'UploadDocumentWithChain' })
      } else if (allImages) {
        this.$router.push({ name: 'CreateSignatureProfile' })
      }
    },

    handleDragDropError(e) {
      this.centralKeyNotActiveFileDropWarning = true
    },

    async listSignatureChainsByStatus(status) {
      // filter if selected
      this.dataTableLoading = true
      let page
      try {
        const q = {
          status: status,
          q: ''
        }
        const pageRequest = {
          'page-num': 1,
          'page-size': 10,
          'sort-field': 'FileName'
          // 'sort-order': this.signatureChainPagination.sortDesc[0] ? 'desc' : 'asc' // TODO due to ScrollingPage
        }
        page = await signatureChains.listMySignatureChains(q, pageRequest)
        this.signatureChainList = page
        this.totalItems = page.total
      } catch (error) {
        console.error(error) // TODO: handle somehow,  dialog is not good i think
      } finally {
        this.dataTableLoading = false
      }
      // page.content.forEach(x => {
      //   this.loadThumbnail(x.origDocument.id).then((res) => { x.thumbnailUrl = res })
      // })
      return page.content
    },

    //  actions

    navToDocuments(filter) {
      this.$router.push({ name: 'SignatureChains', params: { filter: filter } })
    },

    // mounted methods somehow only runs this way
    async loadUserStats() {
      const stats = await users.getMyUserStats()
      this.userStats = stats
    },

    async loadAllSignatureChains() {
      this.signedSignatureChains = await this.listSignatureChainsByStatus(SignatureChainListStatus.SIGNED)
      this.todoSignatureChains = await this.listSignatureChainsByStatus(SignatureChainListStatus.TODO)
      this.pendingSignatureChains = await this.listSignatureChainsByStatus(SignatureChainListStatus.PENDING)
    },

    async refreshSignedChains(chainIdToRemove) {
      if (chainIdToRemove) {
        const chainIdx = this.pendingSignatureChains.find(x => x.id === chainIdToRemove)
        if (chainIdx) { this.pendingSignatureChains = this.pendingSignatureChains.filter(x => x.id !== chainIdToRemove) }
      }
      const list = await this.listSignatureChainsByStatus(SignatureChainListStatus.SIGNED)
      this.signedSignatureChains = list
    },

    async refreshPendingChains(chainIdToRemove) {
      if (chainIdToRemove) {
        const chainIdx = this.todoSignatureChains.find(x => x.id === chainIdToRemove)
        if (chainIdx) { this.todoSignatureChains = this.todoSignatureChains.filter(x => x.id !== chainIdToRemove) }
      }
      const list = await this.listSignatureChainsByStatus(SignatureChainListStatus.PENDING)
      this.pendingSignatureChains = list
    },

    async refreshTodoChains(chainIdToRemove) {
      if (chainIdToRemove) {
        const chainIdx = this.pendingSignatureChains.find(x => x.id === chainIdToRemove)
        if (chainIdx) { this.pendingSignatureChains = this.pendingSignatureChains.filter(x => x.id !== chainIdToRemove) }
      }
      const list = await this.listSignatureChainsByStatus(SignatureChainListStatus.TODO)

      this.todoSignatureChains = list
    },

    async onChainCreated(event) {
      await this.loadUserStats()
      if (this.canUserSign(event)) {
        await this.refreshTodoChains()
      } else {
        await this.refreshPendingChains()
      }
    },

    async onChainUpdated(event) {
      await this.loadUserStats()
      const isUserNext = event.nextUserId && event.nextUserId === this.currentUser.id

      switch (event.status) {
        case SignatureChainStatus.DONE:
          await this.refreshSignedChains(event.id)
          break
        case SignatureChainStatus.DECLINED:

          await this.refreshPendingChains(event.id)
          break
        case SignatureChainStatus.CREATED:
          if (isUserNext || this.canUserSign(await signatureChains.getSignatureChain(event.id))) {
            await this.refreshTodoChains(event.id)
          } else {
            await this.refreshPendingChains(event.id)
          }
          break
        default:
          break
      }
    },

    onChainDeleted(event) {
      this.loadUserStats()

      let filteredList = this.todoSignatureChains.filter(element => element.id !== event.id)
      if (filteredList.length !== this.todoSignatureChains.length) {
        this.todoSignatureChains = filteredList
        return
      }

      filteredList = this.pendingSignatureChains.filter(element => element.id !== event.id)
      if (filteredList.length !== this.pendingSignatureChains.length) {
        this.pendingSignatureChains = filteredList
        return
      }

      filteredList = this.signedSignatureChains.filter(element => element.id !== event.id)
      if (filteredList.length !== this.signedSignatureChains.length) {
        this.signedSignatureChains = filteredList
      }
    },

    canUserSign(item) {
      const usersSignatures = item?.signatures?.filter(x => x.user.id === this.currentUser.id)
      if (usersSignatures.length > 0 && usersSignatures?.some(signature => !signature.signedDocument) && item.status === SignatureChainStatus.CREATED) {
        const currentUserIndex = item?.signatures?.findIndex(signature => usersSignatures.find(x => x.id === signature.id) && !signature.signedAt)
        const previousUserIndex = (currentUserIndex - 1)
        if (currentUserIndex === -1) {
          return false
        }
        if (item.signatures[currentUserIndex].signedDocument) {
          return false
        }
        if (item.type === signatureChainType.UNORDERED || currentUserIndex === 0 || item.signatures[previousUserIndex].signedDocument) {
          return true
        }
      }

      return false
    },
    async listMyActivatedCredentials() {
      try {
        const resp = await rssp.listMyActivatedCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN') && (elem.certChain.length > 0)))

        this.activatedCredentials = resp.content
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
      // showToastError(errorMsg)
      }
    }
  }

}
</script>

<style scoped>
.text-btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 2px !important;
}
.arrow-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 !important;
  min-width: 35px !important;
  margin-left: 1px;
}
.v-list-item:hover {
  color: var(--v-primary-base) !important;
}

</style>
